import { getWebInstrumentations, initializeFaro } from "@grafana/faro-web-sdk";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";

export const initFaro = () =>
  initializeFaro({
    url: "https://faro-collector-prod-eu-west-2.grafana.net/collect/f4995bb691d1ea810df94522441ddc30",
    app: {
      name: "Market Access Hub",
      version: "1.0.0",
      environment: "production"
    },

    instrumentations: [
      // Mandatory, omits default instrumentations otherwise.
      ...getWebInstrumentations(),

      // Tracing package to get end-to-end visibility for HTTP requests.
      new TracingInstrumentation()
    ]
  });
